import apiFleetManager from "@Config/api/clientFleetManager";
import { AuthorizedUserInfo } from "@Types/users";

export const usersApi = {
  /**
   * Retorna as informações do usuário autenticado, incluindo permissionCodes.
   * Usado na inicialização do Keycloak e no carregamento de permissões.
   */
  getAuthorizedUser: (accessToken?: string): Promise<AuthorizedUserInfo> =>
    apiFleetManager
      .get<AuthorizedUserInfo>("api/users/authorized", {
        headers: accessToken
          ? { Authorization: `Bearer ${accessToken}` }
          : undefined,
      })
      .then((res) => res.data),
};
